import { render, staticRenderFns } from "./XCoordinatedPanel.vue?vue&type=template&id=248d40ce&scoped=true&"
import script from "./XCoordinatedPanel.vue?vue&type=script&lang=js&"
export * from "./XCoordinatedPanel.vue?vue&type=script&lang=js&"
import style0 from "./XCoordinatedPanel.vue?vue&type=style&index=0&id=248d40ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d40ce",
  null
  
)

export default component.exports